import {
  call,
  fork,
  select,
  put,
  takeLatest
} from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import { delay } from 'redux-saga';
import dataProvider from '../../../../../util/dataProvider/dataProvider';
import {
  navigationRoutes,
  navigationSteps
} from '../../../navigation/navigationHelpers';
import {
  LOAD_CONTENT
} from './checkout';
import {
  productNameSelector,
  setQuickCheckoutData
 } from '../../../data/quickCheckout/quickCheckout';
import {NORMALIZE_DATA} from '../../../dataProvider/dataProvider';
import {
  errorPageByFlow,
  hideGlobalSpinner
} from '../../../common/common';
import {
  shoppingElementIdSelector,
  priceReferenceIdSelector,
  setData,
  setProductId
} from '../../../data/checkout/checkout';

// WATCHERS
export function* loadContentWatch() {
  yield takeLatest(LOAD_CONTENT, loadContentWorker);
}

export function* normalizeWatch() {
  yield takeLatest(NORMALIZE_DATA, normalizeWorker);
}

// WORKERS
export function* loadContentWorker(action) {
  try {
    const errorPage = yield select(errorPageByFlow);

    // OLD URL PARAM UID ONLY
    if (action.payload.uid) {
      const checkPricingMessage = function*() {
        const productName = yield select(productNameSelector);

        return `Checking pricing for ${productName}...`;
      };

      const checkAvailabilityMessage = function*() {
        const productName = yield select(productNameSelector);

        return `Checking the availability of ${productName}...`;
      };

      const addingProductMessage = function*() {
        const productName = yield select(productNameSelector);

        return `Adding ${productName} to your XFINITY plan...`;
      };

      // ADDED PLAN AND EQUIPMENT FOR DATA LAYER
      const success = yield call(dataProvider.load, [
        {state: 'productMapping', spinnerMessage: 'Looking up your XFINITY Plan...', param: action.payload.uid},
        {state: 'auth', spinnerMessage: 'Looking up your XFINITY Plan...'},
        {state: 'customer', spinnerMessage: 'Looking up your XFINITY Plan...'},
        {state: 'context', spinnerMessage: 'Looking up your XFINITY Plan...'},
        {state: 'plan', spinnerMessage: 'Looking up your XFINITY Plan...'},
        {state: 'offers', spinnerMessage: checkPricingMessage, param: ''},
        {state: 'addDefaultOffer', spinnerMessage: checkPricingMessage},
        {state: 'customerLobAndProduct', spinnerMessage: checkAvailabilityMessage, param: function*() {
          return yield(select(shoppingElementIdSelector));
        }},
        {state: 'configureProduct', spinnerMessage: checkAvailabilityMessage, param: function*() {
          yield delay(0); // HACK: Something is causing the saga not to execute on time - action fires, selector doesn't see state update
          return yield(select(priceReferenceIdSelector));
        }},
        {state: 'review', spinnerMessage: addingProductMessage},
        {state: 'quickCheckoutAnalytics', spinnerMessage: addingProductMessage}
      ], {errorPage});

      if (!success) {
        return;
      }
    } else { // NEW URL PARAM productName and type
      const isPPV = action.payload.checkoutType === 'ppv';

      if (isPPV) yield put(setData({queryType: 'ppv'}));

      const productDisplayName = isPPV ? 'selected event' : action.payload.productName;
      const planMessage = 'Looking up your XFINITY Plan...';
      const checkPricingMessage = `Checking pricing for ${productDisplayName}...`;
      const checkAvailabilityMessage = `Checking the availability of ${productDisplayName}...`;
      const addingProductMessage = `Adding ${productDisplayName} to your XFINITY plan...`;

      // ADDED PLAN AND EQUIPMENT FOR DATA LAYER
      const success = yield call(dataProvider.load, [
        {state: 'auth', spinnerMessage: planMessage},
        {state: 'customer', spinnerMessage: planMessage},
        {state: 'context', spinnerMessage: planMessage},
        {state: 'plan', spinnerMessage: planMessage},
        {state: 'offers', spinnerMessage: checkPricingMessage, param: ''},
        {state: 'addDefaultOffer', spinnerMessage: checkPricingMessage},
        {state: 'productForQuickcheckout', spinnerMessage: checkAvailabilityMessage, param: action.payload},
        {state: 'configureProduct', spinnerMessage: checkAvailabilityMessage, param: function*() {
          yield delay(0); // HACK: Something is causing the saga not to execute on time - action fires, selector doesn't see state update
          return yield(select(priceReferenceIdSelector));
        }},
        {state: 'review', spinnerMessage: addingProductMessage},
        {state: 'quickCheckoutAnalytics', spinnerMessage: addingProductMessage}
      ], {errorPage});

      if (!success) {
        return;
      }
    }

    yield put(hideGlobalSpinner());
    browserHistory.replace(navigationRoutes[navigationSteps.quickCheckout.REVIEW].path);
  } catch(e) {
    //console.log(e)
  }
}

export function* normalizeWorker({key, data, meta}) {
  if (key !== 'productMapping' && key !== 'productForQuickcheckout' && key !== 'customerLobAndProduct') {
    return;
  }

  if (key === 'productMapping') {
    yield put(setData({
      ...meta,
      content: data
    }));
    yield put(setQuickCheckoutData({
      productId: data.shoppingElementId,
      productName: data.productName
    }));
  } else {
    yield put(setProductId(data.priceReferenceId));
  }
}

export default function* checkoutSagas() {
  yield [
    fork(loadContentWatch),
    fork(normalizeWatch)
  ];
}



/** WEBPACK FOOTER **
 ** ./client/redux/modules/pages/QuickCheckout/checkout/checkoutSagas.js
 **/